import React, { useMemo, useState } from 'react';
//assets
import AddIcon from 'img/add-icon.svg';
import AddGrayIcon from 'img/add-gray-icon.svg';
import SecondIconLine from 'img/second-item-line.svg';
//interface
import { INewBudgetButtons } from './interface';
import { BudgetsProps } from 'models/QuoteDetailItem';
//components
import Text from 'components/Text';
import { Visibility } from 'components/Visibility';
import { toastify } from 'components/Toastify/utils';
import { QuotationOriginType, SupplierStatusType } from 'components/Table/interface';
import { VisibilityConditional } from 'components/VisibilityConditional';
import { DuplicateItemLine, LoadingButton, NewAnswerButton, NewBudgetContent, RemoveButton } from './styles';
//services
import QuoteService from 'services/quote.service';
//context
import { useTabsContext } from 'contexts/Tabs';
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//utils
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';

export const NewBudgetButtons: React.FC<INewBudgetButtons> = (props) => {
  const {
    item,
    quoteId,
    productSelected,
    setProductSelected,
    listCdsNotDuplicated,
    distributionCentersLength,
    removeBudgetSaveQuoteItem,
    distributionCenterSelected,
    refreshQuoteSentHeaderTabs
  } = props;
  const budgets = item?.budgets;

  const [loading, setLoading] = useState<boolean>(false);
  const [loadingAddAnswer, setLoadingAddAnswer] = useState<boolean>(false);

  const {
    setQuoteItem,
    quoteItem,
    quoteDetail,
    setFirstLoadPage,
    setSecondDetailPageRender,
  } = useDetailsQuoteContext();
  const { setDisableTabs } = useTabsContext();
  const quoteItemData = quoteItem?.data?.find((item) => item?.productsSuggestion);

  const _quoteService = new QuoteService();

  const sameSequence = useMemo(() => {
    if (quoteItem)
      return quoteItem?.data?.filter(x => x.sequenceNumber === item.sequenceNumber && !x.budgets?.deleted).length;
  }, [quoteItem, item]);

  const lineVisibility = sameSequence === 2 && budgets?.sequence == !1;
  const integrationMessages = quoteDetail?.integrationMessages?.find((message) => message.distributionCenter === distributionCenterSelected);
  const blockedPendingMoney = !(integrationMessages?.statusViveo === SupplierStatusType.PENDING_MONEY);

  const addNewAnswer = (sequenceNumber: string, enrichedProductsSuggestion?: any[]) => {
    const index = quoteItem?.data?.findIndex(x => x.sequenceNumber === sequenceNumber);
    const existItemDeleted = quoteItem?.data?.find(x => x.sequenceNumber === sequenceNumber && x.budgets?.deleted && x.budgets?.sequence === 1);

    if (existItemDeleted && existItemDeleted.budgets)
      existItemDeleted.budgets.deleted = false;

    const newBudgets: BudgetsProps = {
      subUnit: 0,
      sent: false,
      sequence: 1,
      deleted: false,
      isvalid: false,
      medicineType: "",
      packagingType: 0,
      budgetHistory: [],
      productSegment: "",
      conversionAmount: 0,
      quotationMultiple: 0,
      quantityPackaging: "",
      productsSuggestionSegment: "",
      distributionCenter: listCdsNotDuplicated ? listCdsNotDuplicated[0].local : ""
    };

    const newBudget = {
      notes: "",
      stock: "",
      unitPrice: "",
      checked: false,
      isValid: false,
      salePrice: "0",
      packagingType: 0,
      rentability: "0",
      isOriginal: false,
      hasDuplicate: false,
      rentabilitySaved: "",
      conversionAmount: "",
      hasCommercialCost: 0,
      weight: item?.weight,
      id: item?.productCode,
      messageAutoAnswer: [],
      quoteId: item?.quoteId,
      quantity: item?.quantity,
      totalItens: item?.totalItens,
      productCode: item?.productCode,
      outPortfolio: item?.outPortfolio,
      producer: quoteItemData?.producer,
      sequenceNumber: item?.sequenceNumber,
      buyerIdentifier: item?.buyerIdentifier,
      distributionCenter: item?.distributionCenter,
      productsSuggestion: enrichedProductsSuggestion ?? item?.productsSuggestion,
      budgets: existItemDeleted?.budgets ?? newBudgets,
      productOutOfPortfolio: item?.productOutOfPortfolio,
      budgetHistory: existItemDeleted ? existItemDeleted?.budgets?.budgetHistory : [],
      productName: item?.productName,
      preferedBrands: item.preferedBrands,
      unitPurchase: item.unitPurchase
    };

    quoteItem?.data?.splice((Number(index) + 1), existItemDeleted ? 1 : 0, newBudget);
    quoteItem && setQuoteItem({ ...quoteItem, data: quoteItem?.data });
  };

  const handleAddNewAnswer = async (sequenceNumber: string) => {
    setLoadingAddAnswer(true);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    try {
      const result = await _quoteService.suggestionDetailsSendQuotationOrder2(
        quoteId,
        distributionCenterSelected ?? "",
        sequenceNumber
      );

      clearTimeout(timeoutId);

      if (result?.data && Array.isArray(result?.data) && result.data.length > 0) {
        const enrichedItem = result.data.find((d: any) => d.sequenceNumber === sequenceNumber);
        addNewAnswer(sequenceNumber, enrichedItem?.productsSuggestion);
      } else {
        toastify.error("De/para na ordem 2 não encontrado. Clique em \"Adicionar resposta\" para tentar novamente.");
      }
    } catch (err: any) {
      clearTimeout(timeoutId);
      const isTimeout = err instanceof DOMException && err.name === 'AbortError';
      const is504 = err?.response?.status === 504 || err?.status === 504;

      toastify.error(
        isTimeout || is504
          ? "Tempo limite excedido ao consultar o Money. Clique em \"Adicionar resposta\" para tentar novamente."
          : "Falha ao carregar de/para na ordem 2. Clique em \"Adicionar resposta\" para tentar novamente."
      );
    } finally {
      setLoadingAddAnswer(false);
    }
  };

  const removeItem = (budget?: BudgetsProps) => {
    if (budget)
      budget.deleted = true;

    removeBudgetSaveQuoteItem();

    if (item.budgets && item.budgets?.sequence === 1) {
      let newItens = [...productSelected];
      newItens.splice(newItens.findIndex(x => x.sequenceNumber === item.sequenceNumber && x.sequence === 1), 1);
      setProductSelected(newItens);
    }

    if (quoteItem?.data?.length && quoteItem?.data?.length > 1) {
      quoteItem && setQuoteItem({ ...quoteItem, data: quoteItem?.data });
    } else {
      setDisableTabs(true);
      setFirstLoadPage(true);
      setSecondDetailPageRender(true);
      refreshQuoteSentHeaderTabs && refreshQuoteSentHeaderTabs();
      setQuoteItem(undefined);
    }
  };

  const deleteAnswer = async (quoteId: string, sequenceNumber: string, sequenceBudget: number) => {
    setLoading(true);
    const item = quoteItem?.data?.find(x => x.sequenceNumber === sequenceNumber && x.budgets?.sequence === 1 && !x.budgets?.deleted && !IsNullOrEmpty(x.budgets.budgetSaved));
    const itemRemoved = quoteItem?.data?.find(x => x.sequenceNumber === sequenceNumber && x.budgets?.sequence === 1);

    if (item) {
      const response = await _quoteService.resetBuget({ quoteId, sequenceNumber, sequenceBudget, deleted: true });
      if (response.status === 200) {
        removeItem(item.budgets);
      } else {
        toastify.error("Não foi possível remover o orçamento");
      }
    } else {
      removeItem(itemRemoved?.budgets);
    }

    setLoading(false);
  };

  const ableColor = sameSequence !== 2 && !item.hasDuplicate && distributionCentersLength > 1;
  const disabledRemove = item.hasDuplicate && !item.isOriginal && blockedPendingMoney;

  return (
    <>
      <Visibility visible={lineVisibility}>
        <DuplicateItemLine>
          <img src={SecondIconLine} />
        </DuplicateItemLine>
      </Visibility>
      <NewBudgetContent>
        {quoteDetail?.origin !== QuotationOriginType.MVM && 
          <NewAnswerButton
            able={ableColor && !loadingAddAnswer}
            disabled={sameSequence === 2 && item.hasDuplicate || distributionCentersLength === 1 || loadingAddAnswer}
            onClick={() => ableColor && !loadingAddAnswer && handleAddNewAnswer(item?.sequenceNumber)}
            children={
              <VisibilityConditional
                condition={!loadingAddAnswer}
                firstOption={() => (
                  <>
                    <img src={ableColor ? AddIcon : AddGrayIcon} />
                    <Text>Adicionar resposta</Text>
                  </>
                )}
                secondOption={() => (<LoadingButton onlySpinner size={14} />)}
              />
            } 
          />
        }
        <Visibility visible={budgets?.sequence === 1 && !budgets?.deleted}>
          <RemoveButton
            disabled={disabledRemove}
            onClick={() => deleteAnswer(quoteId, item?.sequenceNumber, 1)}
            children={
              <VisibilityConditional
                condition={!loading}
                firstOption={() => (<Text>Remover</Text>)}
                secondOption={() => (<LoadingButton onlySpinner size={14} />)}
              />
            } />
        </Visibility>
      </NewBudgetContent>
    </>
  );
};